<template>
  <div class="LoadingIndicator">
    <ClipLoader
      v-if="loaderType === 'clip'"
      :color="loaderColor"
      :size="!size ? undefined : size"
      size-unit="px"
    />
    <BarLoader
      v-if="loaderType === 'bar'"
      :color="loaderColor"
      :size="!size ? undefined : size"
      size-unit="px"
    />
  </div>
</template>

<script>
import { ClipLoader, BarLoader } from '@saeris/vue-spinners';

export default {
  name: 'LoadingIndicator',
  components: {
    ClipLoader,
    BarLoader,
  },
  props: {
    loaderType: {
      type: String,
      default: 'clip',
      validator: value =>
        // The value must match one of these strings
        ['clip', 'bar'].indexOf(value) !== -1,

    },
    loaderColor: {
      type: String,
      default: '#cc3f3f', // $color--primary
    },
    size: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.LoadingIndicator {
  height: 100%;
  position: relative;
  @include z-index(loader);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
